/* eslint-disable */
/* tslint:disable */
// @ts-nocheck
/*
 * ---------------------------------------------------------------
 * ## THIS FILE WAS GENERATED VIA SWAGGER-TYPESCRIPT-API        ##
 * ##                                                           ##
 * ## AUTHOR: acacode                                           ##
 * ## SOURCE: https://github.com/acacode/swagger-typescript-api ##
 * ---------------------------------------------------------------
 */

import { Injectable } from "@jkhy/frontend-utils/di";
import { TmHttpClient } from "@treasury/core/http";
import { createSwaggerClient } from "../../utils/tm-swagger-client";

import {
    ChangePasswordViewModelDto,
    CredentialDto,
    ErrorHttpContentDto,
    InitialLoginCredentialModelDto,
    RecentLoginsModelDto,
    RegisterSecureTokenMfaRequestModelDto,
    RegisterSecureTokenMfaResponseModelDto,
    SecureTokenMfaCredentialsResponseModelDto,
    SecureTokenMfaLoginRequestModelDto,
    SecureTokenMfaLoginResponseModelDto,
    SecurityQuestionModelDto,
    TextKeyCollectionDto,
    UserModelDto,
    UserSettingsModelDto,
} from "../";
import { ContentType, HttpClient, RequestParams } from "./http-client";

@Injectable()
export class AccountClient {
  private readonly http: HttpClient;

  constructor(tmHttp: TmHttpClient) {
    this.http = createSwaggerClient(tmHttp, HttpClient);
  }

  /**
 * No description
 *
 * @tags Account
 * @name AccountLogin
 * @summary Initiates login for an FI user, checking initial login credentials and possibly MFA.
Returns login credentials model.
 * @request POST:/account/login
 */
  accountLogin = (data: UserModelDto, params: RequestParams = {}) =>
    this.http.request<InitialLoginCredentialModelDto, ErrorHttpContentDto>({
      path: `/account/login`,
      method: "POST",
      body: data,
      type: ContentType.Json,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags Account
   * @name AccountAuthenticateSecureToken
   * @summary Authenticates a secure token.
   * @request POST:/account/authenticatesecuretoken
   */
  accountAuthenticateSecureToken = (
    data: SecureTokenMfaLoginRequestModelDto,
    params: RequestParams = {},
  ) =>
    this.http.request<SecureTokenMfaLoginResponseModelDto, ErrorHttpContentDto>(
      {
        path: `/account/authenticatesecuretoken`,
        method: "POST",
        body: data,
        type: ContentType.Json,
        format: "json",
        ...params,
      },
    );
  /**
   * No description
   *
   * @tags Account
   * @name AccountRegisterSecureToken
   * @summary Registers a secure token.
   * @request POST:/account/registersecuretoken
   */
  accountRegisterSecureToken = (
    data: RegisterSecureTokenMfaRequestModelDto,
    params: RequestParams = {},
  ) =>
    this.http.request<
      RegisterSecureTokenMfaResponseModelDto,
      ErrorHttpContentDto
    >({
      path: `/account/registersecuretoken`,
      method: "POST",
      body: data,
      type: ContentType.Json,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags Account
   * @name AccountGetSecureTokenCredentials
   * @summary Gets the users secure token credentials.
   * @request GET:/account/securetokencredentials
   */
  accountGetSecureTokenCredentials = (params: RequestParams = {}) =>
    this.http.request<
      SecureTokenMfaCredentialsResponseModelDto,
      ErrorHttpContentDto
    >({
      path: `/account/securetokencredentials`,
      method: "GET",
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags Account
   * @name AccountLogout
   * @summary Ends the user's session.
   * @request GET:/account/logout
   */
  accountLogout = (
    query?: {
      /** @default "" */
      reason?: string;
    },
    params: RequestParams = {},
  ) =>
    this.http.request<File, ErrorHttpContentDto>({
      path: `/account/logout`,
      method: "GET",
      query: query,
      ...params,
    });
  /**
   * No description
   *
   * @tags Account
   * @name AccountSecurityQuestions
   * @summary Save Security Question and Answers
   * @request POST:/account/securityquestions
   */
  accountSecurityQuestions = (
    data: SecurityQuestionModelDto[],
    params: RequestParams = {},
  ) =>
    this.http.request<boolean, ErrorHttpContentDto>({
      path: `/account/securityquestions`,
      method: "POST",
      body: data,
      type: ContentType.Json,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags Account
   * @name AccountVerifySecurityQuestions
   * @summary Validate MFA Challenge Questions Answers
   * @request PUT:/account/verifysecurityquestions
   */
  accountVerifySecurityQuestions = (
    data: SecurityQuestionModelDto[],
    params: RequestParams = {},
  ) =>
    this.http.request<CredentialDto, ErrorHttpContentDto>({
      path: `/account/verifysecurityquestions`,
      method: "PUT",
      body: data,
      type: ContentType.Json,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags Account
   * @name AccountVerifyUser
   * @summary Initiates login in context of new user credentials.
   * @request PUT:/account/verifyuser
   */
  accountVerifyUser = (data: UserModelDto, params: RequestParams = {}) =>
    this.http.request<InitialLoginCredentialModelDto, ErrorHttpContentDto>({
      path: `/account/verifyuser`,
      method: "PUT",
      body: data,
      type: ContentType.Json,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags Account
   * @name AccountVerifyUserForPasswordReset
   * @summary Initiates login in context of resetting an existing user.
   * @request PUT:/account/VerifyUserForPasswordReset
   */
  accountVerifyUserForPasswordReset = (
    data: UserModelDto,
    params: RequestParams = {},
  ) =>
    this.http.request<InitialLoginCredentialModelDto, ErrorHttpContentDto>({
      path: `/account/VerifyUserForPasswordReset`,
      method: "PUT",
      body: data,
      type: ContentType.Json,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags Account
   * @name AccountUpdatePassword
   * @summary Update User Password
   * @request PUT:/account/updatepassword
   */
  accountUpdatePassword = (data: UserModelDto, params: RequestParams = {}) =>
    this.http.request<ChangePasswordViewModelDto, ErrorHttpContentDto>({
      path: `/account/updatepassword`,
      method: "PUT",
      body: data,
      type: ContentType.Json,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags Account
   * @name AccountPasswordRequirements
   * @summary Get Password Strength Requirements
   * @request GET:/account/passwordrequirements
   */
  accountPasswordRequirements = (
    query?: {
      fiId?: string;
    },
    params: RequestParams = {},
  ) =>
    this.http.request<TextKeyCollectionDto, ErrorHttpContentDto>({
      path: `/account/passwordrequirements`,
      method: "GET",
      query: query,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags Account
   * @name AccountGetOnDemandMfaChallengeSecurityQuestions
   * @summary Validate MFA Challenge Questions Answers
   * @request PUT:/account/getOnDemandMfaChallengeSecurityQuestions
   */
  accountGetOnDemandMfaChallengeSecurityQuestions = (
    data: UserModelDto,
    params: RequestParams = {},
  ) =>
    this.http.request<CredentialDto, ErrorHttpContentDto>({
      path: `/account/getOnDemandMfaChallengeSecurityQuestions`,
      method: "PUT",
      body: data,
      type: ContentType.Json,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags Account
   * @name AccountSettings
   * @request GET:/account/settings
   */
  accountSettings = (params: RequestParams = {}) =>
    this.http.request<UserSettingsModelDto, ErrorHttpContentDto>({
      path: `/account/settings`,
      method: "GET",
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags Account
   * @name AccountCurrentFiDateTime
   * @summary Retrieves the current date time for the financial institution
   * @request GET:/account/currentFiDateTime
   */
  accountCurrentFiDateTime = (params: RequestParams = {}) =>
    this.http.request<string | null, ErrorHttpContentDto>({
      path: `/account/currentFiDateTime`,
      method: "GET",
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags Account
   * @name AccountRecentLogins
   * @request GET:/account/recentLogins
   */
  accountRecentLogins = (params: RequestParams = {}) =>
    this.http.request<RecentLoginsModelDto, ErrorHttpContentDto>({
      path: `/account/recentLogins`,
      method: "GET",
      format: "json",
      ...params,
    });
}
